import Axios2 from "@/utils/Axios2";

/**
 * 打开添加弹窗
 */
export function openAddPopup(context) {
  resetPopup(context);
  context.showPopup = true;
}

/**
 * 打开人工评审弹窗
 */
export function openFixPopup(context) {
  resetPopup2(context);
  context.showPopup2 = true;
  context.getChangeList();
}

/**
 * 查询线下检查列表
 */
export function getCheckList(context) {
  let param = {};
  param.method= "get";
  param.url="/api/v1/monitor/inspection/page";
  param.params = {
    monitorSiteId : context.saveid,
    pageNum : context.pageNum,
    pageSize : context.pageSize,
  }
  return Axios2.ajax(param).then((res) => {
    context.CheckList = res.data.records;
    context.checkTotal = res.data.total;
  })
}

/**
 * 获取人工修改内容
 */
export function getChangeList(context){
  let param = {};
  param.method = 'get';
  param.url = '/api/v1/monitorSite/manualAnalysis/list'
  param.params = {
    monitorSiteId: context.saveid,
  }
  return Axios2.ajax(param).then((res) => {
    if(res.data && Array.isArray(res.data) && res.data.length > 0){
      context.fixChangeList = res.data;
      // const record = res.data[0];
      // context.changeId = record.id;
      // context.isRiskChange = true;
      // context.mainRisk = String(record.mainRiskId);
      // context.riskIds = record.riskIds.map(String);
      // context.changeRiskTime = record.analysisTargetTime;
      // context.riskContent = record.content;
      // context.publishStatus = record.publishStatus;
    } else {
      context.fixChangeList = [];
      // context.isRiskChange = false;
      // context.changeId = '';
      // context.mainRisk = '';
      // context.riskIds = [];
      // context.changeRiskTime = '';
      // context.riskContent = '';
      // context.publishStatus = '0';
    }
  })
}

/**
 * 编辑检查详情
 */
export function editCheckDetail(context, row) {
  context.inspector = row.inspector;
  context.inspectionTime = row.inspectionTime;
  context.issueDescription = row.issueDescription;
  context.issueUrls = row.issueUrl || [];
  context.issuePaths = row.issuePath || [];
  context.issueThumbnailPaths = row.issueThumbnailPath || [];
  context.issueThumbnailUrls = row.issueThumbnailUrl || [];
  context.editCheckId = row.id;
  context.isEditMode = true;
  context.showPopup = true;
  context.isUploading = false;
}

/**
 * 编辑人工评审部分
 */
export function editFixDetail(context, items){
  context.fixAdd = true;
  context.showAddDrawer = true;
  context.isRiskChange = true;
  context.fixDelete = true;
  context.changeId = items.id;
  context.mainRisk = String(items.mainRiskId);
  context.riskIds = items.riskIds !== undefined ? items.riskIds.map(String) : [];
  context.changeRiskTime = items.analysisTargetTime;
  context.riskContent = items.content;
  context.publishStatus = String(items.publishStatus);
}

/**
 * 删除对应相关人工分析结果
 */
export function deleteFixDetail(context ,id){
  const param = {
    method: 'post',
    url: `/api/v1/monitorSite/manualAnalysis/delete`,
    params:{
      id:id,
    }
  };
  return Axios2.ajax(param).then((res) => {
    if (res.code === 0){
      context.$message.success("删除成功");
      context.getChangeList();
      context.fixAdd = false;
    } else {
      console.error(res);
      context.$message.error("删除失败");
      context.getChangeList();
      context.fixAdd = false;
    }
  })
}
/**
 * 上传前检查文件
 */
export function beforeUpload(context, file) {
  const isPicture = file.type === 'image/jpeg' || file.type === 'image/png';
  const PictureSize = file.size < 15 * 1024 * 1024;
  if (!isPicture) {
    context.$message.error('只能上传 JPG/PNG格式 的图片');
    return false;
  }
  if (!PictureSize) {
    context.$message.error('只能上传 15MB以内大小 的图片');
    return false;
  }
  return true;
}

/**
 * 自定义上传
 */
export function customUpload(context, { file }) {
  context.isUploading = true;

  const formData = new FormData();
  formData.append('file', file);
  const param = {
    method: 'post',
    url: '/api/v1/monitor/inspection/uploadPicture',
    data: formData
  };
  return Axios2.ajax(param)
    .then((res) => {
      if (res.code === 0 && res.data) {
        if (context.issueThumbnailUrls.length >= 5) {
          context.$message.warning('最多只能上传5张图片');
          return;
        }

        const extractUrl = (str) => {
          const match = str.match(/https?:\/\/[^\s<]+/);
          return match ? match[0] : '';
        };

        const pictureUrl = extractUrl(res.data.pictureUrl);
        const thumbnailUrl = extractUrl(res.data.thumbnailUrl);

        //推送上传图片获取的数据
        context.issueUrls.push(pictureUrl);
        context.issueThumbnailUrls.push(thumbnailUrl);
        context.issuePaths.push(res.data.picturePath);
        context.issueThumbnailPaths.push(res.data.thumbnailPath);

        context.$message.success('上传成功');
      } else {
        context.$message.error(res.message || '上传失败');
      }
    })
    .catch((err) => {
      console.error('上传请求失败：', err);
      context.$message.error('上传请求失败');
    })
    .finally(() => {
      context.isUploading = false;
    });
}

/**
 * 移除图片
 */
export function removeImage(context, index) {
  context.issueUrls.splice(index, 1);
  context.issuePaths.splice(index, 1);
  context.issueThumbnailPaths.splice(index, 1);
  context.issueThumbnailUrls.splice(index, 1);
}

/**
 * 确认插入
 */
export function confirmInsert(context) {
  const isEdit = context.isEditMode;
  const url = '/api/v1/monitor/inspection'
  const method = isEdit ? 'put' : 'post';

  const param = {
    method,
    url,
    data: {
      monitorSiteId: context.saveid,
      inspector: context.inspector,
      inspectionTime: context.inspectionTime,
      issueDescription: context.issueDescription,
      issuePath: context.issuePaths,
      issueThumbnailPath: context.issueThumbnailPaths,
      ...(isEdit && { id: context.editCheckId })
    }
  };

  return Axios2.ajax(param).then(res => {
    if (res.code === 0) {
      context.$message.success(isEdit ? '修改成功' : '新增成功');
      context.getCheckList();
      resetPopup(context);
    } else {
      context.$message.error(res.msg || '操作失败');
    }
  });
}

/**
 * 确认人工修改结果
 */
export function confirmChangeRisk(context){
  const isEdit = context.isRiskChange;
  const url = isEdit ? '/api/v1/monitorSite/manualAnalysis/update' : '/api/v1/monitorSite/manualAnalysis/add';
  const method = 'post';
  const param = {
    method,
    url,
    data:{
      monitorSiteId: context.saveid,
      riskIds:context.riskIds,
      mainRiskId:context.mainRisk,
      content:context.riskContent,
      analysisTargetTime:context.changeRiskTime,
      publishStatus:context.publishStatus,
      ...(isEdit && { id: context.changeId })
    }
  }

  return Axios2.ajax(param).then((res) => {
    if (res.code === 0) {
      context.$message.success('修改成功');
      context.getChangeList()
      context.showAddDrawer = false;
      resetPopup2(context);
    } else {
      context.$message.error(res.msg || '修改失败');
    }
  })
}

/**
 * 重置弹窗
 */
export function resetPopup(context) {
  // 检查是否有内容需要保存
  const hasContent = context.inspector || context.inspectionTime || context.issueDescription ||
                     (context.issueUrls && context.issueUrls.length > 0);

  if (hasContent) {
    context.$confirm('是否保存当前内容？', '提示', {
      confirmButtonText: '保存',
      cancelButtonText: '不保存',
      type: 'warning'
    }).then(() => {
      // 用户选择保存，执行保存逻辑
      confirmInsert(context).then(() => {
        // 保存成功，关闭弹窗
        closePopup(context);
      }).catch(() => {
        // 保存失败，不关闭
      });
    }).catch(() => {
      // 用户选择不保存，直接关闭
      closePopup(context);
    });
  } else {
    // 没有内容，直接关闭
    closePopup(context);
  }
}

/**
 * 关闭弹窗并清空数据
 */
function closePopup(context) {
  context.showPopup = false;
  context.inspector = '';
  context.inspectionTime = '';
  context.issueDescription = '';
  context.issueUrls = [];
  context.issuePaths = [];
  context.issueThumbnailPaths = [];
  context.issueThumbnailUrls = [];
  context.editCheckId = '';
  context.isEditMode = false;
}

/**
 * 重置人工更改弹窗
 */
export function resetPopup2(context){
  context.fixAdd = false;
  context.fixDelete = false;
  context.mainRisk = '';
  context.riskIds = [];
  context.riskContent = '';
  context.changeRiskTime = '';
  context.publishStatus = '0';
}
/**
 * 删除详情
 */
export function deleteDetail(context, id) {
  return Axios2.ajax({
    url: `/api/v1/monitor/inspection/${id}`,
    method: 'DELETE'
  }).then((res) => {
    if (res.code === 0) {
      context.$message({
        type: 'success',
        message: '删除成功'
      })
      context.getCheckList();
    } else {
      context.$message({
        type: 'error',
        message: res.msg || '删除失败'
      })
      context.getCheckList();
    }
  }).catch((error) => {
    context.$message({
      type: 'error',
      message: error.message || '删除请求失败'
    })
  })
}

/**
 * 发布人工评断内容
 */
export function upFix(context, id){
  return Axios2.ajax({
    url: `/api/v1/monitorSite/manualAnalysis/publish`,
    method: 'POST',
    params:{
      id: id,
      publishStatus: 1
    }
  }).then((res) => {
    if (res.code === 0) {
      context.$message({
        type: 'success',
        message: '发布成功'
      })
      context.getChangeList()
    }else {
      context.$message.error(res.msg || '修改失败');
    }
  })
}

/**
 * 取消发布人工评断内容
 */
export function cancelPublish(context, id){
  return Axios2.ajax({
    url: `/api/v1/monitorSite/manualAnalysis/publish`,
    method: 'POST',
    params:{
      id: id,
      publishStatus: 0
    }
  }).then((res) => {
    if (res.code === 0) {
      context.$message({
        type: 'success',
        message: '取消发布成功'
      })
      context.getChangeList()
    }else {
      context.$message.error(res.msg || '取消发布失败');
    }
  })
}

/**
 * 打开图片
 */
export function openImage(context, imageUrl) {
  if (imageUrl) {
    window.open(imageUrl, '_blank');
  } else {
    context.$message.warning('暂时未上传图片')
  }
}
